import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class EmailTemplateListItem extends SearchModelBase {
    id: number = 0;
    reportType: string ='';
    name: string = "";
    templateText: string ="";
    typeDefault: boolean = false;

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: '', width: 30, dataIndex: 'status', hiddenInColumnSetup: true}),
        XCol.Create({ col: 1, text: 'Report Type', width: 200, dataIndex: 'reportType'}),
        XCol.Create({ col: 2, text: 'Name', width: 300, dataIndex: 'name'}),
        XCol.Create({ col: 3, text: 'Default', width: 50, dataIndex: 'typeDefault', type: XCol.XCellType.Bool}),
        ];


    public static getExportCollection(): XCol.XExportColumn[] {
      return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: EmailTemplateListItem.prototype.id, orderByAscending: false };

    public static formatData(data: EmailTemplateListItem[]) {
        return data.map((d: EmailTemplateListItem) => ({
          ...d,
        }));
    }

    public static MapSearchFields:{[key: string]: {[key: string]: string}} = {
   
    }
}
